import { render, staticRenderFns } from "./Broadcast.vue?vue&type=template&id=2f82040e"
import script from "./Broadcast.vue?vue&type=script&lang=js"
export * from "./Broadcast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports